module.exports = __webpack_public_path__ + "img/virsody-logo-blue-v2.ef057a63.svg";